import React, { useState } from 'react';

import { SearchPlanningDTO } from '@recurrency/core-api-schema/dist/search/getSearchPlanning';

import { FlexSpace } from 'components/FlexSpace';
import { ExternalLink } from 'components/Links';
import { EquationPopover } from 'components/recipes/equation/EquationPopover';

import { ProjectedInventoryChangeEquation } from './equations/ProjectedInventoryChangeEquation';

export const ProjectedInventoryChangePopover = ({
  record,
  context = 'planning',
}: {
  record: SearchPlanningDTO;
  context?: 'planning' | 'dailyWorkflow';
}) => {
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);
  // This is to reset the visibility to undefined so it can be opened on hover after it is closed
  const onVisibleChange = (isVisible: boolean) => {
    const visibility = isVisible === false ? undefined : isVisible;
    setIsOpen(visibility);
  };

  const getTooltipText = () => {
    if (record.recurrency_replenishment_method === 'OP/OQ') {
      return 'For OP/OQ items, projected inventory change calculates the dollar impact of changing from your current average inventory level to a new average inventory level.';
    }
    return 'The projected inventory change is calculated from the distance between the midpoints (average of min and max) of the current and suggested recommendations.';
  };

  return (
    <EquationPopover title="Projected Inventory Change Calculation" visible={isOpen} onVisibleChange={onVisibleChange}>
      <FlexSpace direction="column">
        <span>{getTooltipText()}</span>
        <ProjectedInventoryChangeEquation record={record} context={context} />
        <span>
          Learn more about projected inventory change{' '}
          <ExternalLink to="https://help.recurrency.com/hc/en-us/articles/33803243235739-Projected-Inventory-Change">
            here
          </ExternalLink>
          .
        </span>
      </FlexSpace>
    </EquationPopover>
  );
};
